enum PaymentType {
  NEW_CARD = "new card",
  REWARD_WALLET = "reward wallet",
  SAVED_CARD = "saved card"
}

export default PaymentType
